<template>
  <div class="relative-position inline">
    <q-btn
      class="profile_image"
      round
      padding="none"
      :disable="disable"
      :ripple="clickable"
      :class="classes"
      :loading="loading"
      @click="onClick"
    >
      <!-- Render image / initials -->
      <q-avatar
        :size="size"
        :text-color="!dark ? 'white' : 'black'"
        :style="{'background-color': color}"
        class="avatar"
      >
        <q-img
          v-if="profileImage"
          :src="profileImage"
          :no-transition="noAnimation"
          position="center"
          ratio="1"
        />
        <template v-else>
          {{ initials }}
        </template>
      </q-avatar>

      <!-- Additional content -->
      <slot />

      <!-- Tooltip -->
      <q-tooltip
        v-if="!disable && (error || tooltip)"
        :class="{'bg-red-8': !!error}"
      >
        {{ error || tooltip }}
      </q-tooltip>

      <!-- Additional icon -->
      <q-btn
        v-if="!!additionalIcon && clickable"
        dense
        size="12px"
        round
        class="absolute-bottom-right no-pointer-events"
        color="blue-grey-8"
        style="bottom: -2px; right: -2px;"
        :icon="additionalIcon"
      />
    </q-btn>
  </div>
</template>

<script>
/**
 * Profile Image of an object
 *
 * SLOTS:
 * - default
 * - tooltip: custom element to display inside the tooltip
 *
 * EVENTS:
 * - click: when profile image or additional button is clicked
 */
export default {
  props: {
    // Initials to display if an image is not supplied
    initials: {
      type: String,
      default: '#'
    },
    // URL of image to display
    profileImage: {
      type: String
    },
    // Size of element (Quasar sizing properties)
    size: {
      type: String,
      default: 'md'
    },
    // Can the element be clicked
    clickable: {
      type: Boolean,
      default: false
    },
    // Display a loading spinner inside element if loading
    loading: {
      type: Boolean,
      default: false
    },
    // Text to display when mouse is hovered over the element
    tooltip: {
      type: String,
      default: null
    },
    // Hex color to use on element background (if image is not supplied)
    color: {
      type: String,
      default: '#027BE3'
    },
    // Disable clicking ProfileImage
    disable: {
      type: Boolean,
      default: false
    },
    // Shadow behind element
    shadow: {
      type: Number,
      default: 1
    },
    // Disable the animation when profile URL has loaded
    noAnimation: {
      type: Boolean,
      default: false
    },
    // Disable an additional button at the bottom right
    additionalIcon: {
      type: String,
      default: null
    },
    // Error message
    error: {
      type: String,
      default: null
    },
    // Show outline around btn
    master: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  computed: {
    dark () {
      return this.checkBrightnessOfHex(this.color) > 170
    },
    classes () {
      return {
        'no-pointer-events': !this.clickable,
        'error': !!this.error,
        ['shadow-' + this.shadow]: true,
        'master': this.master
      }
    }
  },
  methods: {
    onClick () {
      if (!this.clickable) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>
